import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface CelebrationProps {
  type: 'success' | 'wrong' | null;
  color?: string;
}
function Particle({
  color,
  delay,
  x,
  y
}: {
  color: string;
  delay: number;
  x: number;
  y: number;
}) {
  return <motion.div className="absolute w-3 h-3 rounded-full pointer-events-none" style={{
    backgroundColor: color,
    left: `${x}%`,
    top: `${y}%`
  }} initial={{
    opacity: 1,
    scale: 1
  }} animate={{
    opacity: 0,
    scale: 0,
    x: (Math.random() - 0.5) * 300,
    y: Math.random() * -200 - 50
  }} transition={{
    duration: 1.2,
    delay,
    ease: 'easeOut'
  }} data-id="element-23" />;
}
export function Celebration({
  type,
  color = '#E2001A'
}: CelebrationProps) {
  const [particles, setParticles] = useState<{
    id: number;
    x: number;
    y: number;
    color: string;
    delay: number;
  }[]>([]);
  useEffect(() => {
    if (type === 'success') {
      const colors = [color, '#FFD700', '#00C853', '#2196F3', '#FF6D00', color];
      const newParticles = Array.from({
        length: 30
      }, (_, i) => ({
        id: Date.now() + i,
        x: 30 + Math.random() * 40,
        y: 30 + Math.random() * 40,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: Math.random() * 0.3
      }));
      setParticles(newParticles);
      setTimeout(() => setParticles([]), 2000);
    }
  }, [type, color]);
  return <>
      {/* Screen flash */}
      <AnimatePresence data-id="element-24">
        {type === 'success' && <motion.div className="fixed inset-0 pointer-events-none z-[100]" initial={{
        backgroundColor: 'rgba(0, 200, 83, 0.3)'
      }} animate={{
        backgroundColor: 'rgba(0, 200, 83, 0)'
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-25" />}
        {type === 'wrong' && <motion.div className="fixed inset-0 pointer-events-none z-[100]" initial={{
        backgroundColor: 'rgba(220, 38, 38, 0.25)'
      }} animate={{
        backgroundColor: 'rgba(220, 38, 38, 0)'
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-26" />}
      </AnimatePresence>

      {/* Confetti particles */}
      <div className="fixed inset-0 pointer-events-none z-[101] overflow-hidden" data-id="element-27">
        {particles.map(p => <Particle key={p.id} color={p.color} delay={p.delay} x={p.x} y={p.y} data-id="element-28" />)}
      </div>
    </>;
}